import { IntegrationType, IntegrationViewFragment } from 'generated/graphql';

interface GetIsUserOrAccountIntegrationAlreadyConnected {
  connectedIntegrations: IntegrationViewFragment[];
  integrationType: IntegrationType;
}

export const getIsUserOrAccountIntegrationAlreadyConnected = ({
  connectedIntegrations,
  integrationType,
}: GetIsUserOrAccountIntegrationAlreadyConnected) => {
  if (
    integrationType !== IntegrationType.User &&
    integrationType !== IntegrationType.Account
  ) {
    return false;
  }

  return Boolean(
    connectedIntegrations.find(
      (integration) =>
        integration.integrationType === integrationType && integration.isActive,
    ),
  );
};
